import { render } from "./ErrorPageView.vue?vue&type=template&id=052d197a"
import script from "./ErrorPageView.vue?vue&type=script&lang=js"
export * from "./ErrorPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__